import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import { formatKosovoDate } from '../../../utils/dateUtils'
export const applicantTableColumns = [
  {
    name: 'Firstname',
    label: 'Firstname',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Lastname',
    label: 'Lastname',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Email',
    label: 'Email',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Position',
    label: 'Position',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Location',
    label: 'Location',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Language',
    label: 'Language',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Date',
    label: 'Application date',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'Status',
    label: (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        Actual Status
        <ArrowUpwardIcon style={{ fontSize: '16px' }} />
      </span>
    ),
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value) => {
        const showBlacklistBadge = value?.blacklistMatch && !value?.blacklistMatchDismissed
        const showFormerEmployeeBadge = value?.exEmployee && !value?.exEmployeeDismissed

        const alertBadgeStyle = {
          padding: '3px 6px',
          borderRadius: '3px',
          fontSize: '9px',
          fontWeight: 600,
          letterSpacing: '0.3px',
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
          display: 'block',
          width: '100%',
          textAlign: 'center'
        }

        return (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '4px' }}>
            {showBlacklistBadge && (
              <span className='badge bg-warning' style={alertBadgeStyle}>
                Potential in blacklist
              </span>
            )}
            {showFormerEmployeeBadge && (
              <span className='badge bg-warning' style={alertBadgeStyle}>
                Former employee
              </span>
            )}
            <span
              className='badge bg-info'
              style={{
                padding: '10px',
                borderRadius: '3px',
                letterSpacing: '1.2px',
                display: 'block',
                width: '100%',
                textAlign: 'center'
              }}
            >
              {value?.status}
            </span>
            {value?.statusKey === 'interview' && value?.interview_date && (
              <span style={{ fontSize: '10px', color: '#6c757d', marginTop: '0', textAlign: 'center' }}>
                {formatKosovoDate(value.interview_date)}
              </span>
            )}
          </div>
        )
      }
    }
  },
  {
    name: 'More',
    label: 'More',
    options: {
      filter: false,
      sort: false,
      download: false
    }
  }
]
